import React from "react";
import PropTypes from "prop-types";
import "./InnerPie.scss";
import { CustomPie } from "../..";

const InnerPie = ({ gradient, percent }) => {
  return (
    <div className="inner-pie">
      <CustomPie 
        gradient={gradient}
        percent={percent}
        pieSize={75}
        strokeWidth={5}
        hasTooltip
      />  
    </div>
  )
}

InnerPie.propTypes = {
  gradient: PropTypes.string,
  percent: PropTypes.number
};

InnerPie.defaultProps = {
  gradient: "",
  percent: 0
};

export default InnerPie;
